import { render, staticRenderFns } from "./AvatarWithTooltip.vue?vue&type=template&id=317ab413&"
import script from "./AvatarWithTooltip.vue?vue&type=script&lang=ts&"
export * from "./AvatarWithTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports